module.exports = __webpack_public_path__ + "ade61119472a0e6b0acb659e326f7047.svg";